import React from "react";
import { useTranslation } from "react-i18next";
import { formInputStyles } from "../../../shared/constants/styles";
import {
  ActionIconContainer,
  AddFormButton,
} from "../../../shared/components/TableElements";
import { Container, Modal, Row, Col } from "react-bootstrap";
import {
  FormGroupLabel,
  FormItem,
} from "../../../shared/components/form/FormElements";
import Error from "@/shared/components/form/Error";

const CreateEquipmentTypePopup = ({
  show,
  onClose,
  onAddEquipmentType,
  equipmentTypePopupErr,
}) => {
  const { t } = useTranslation("common");
  const [equipmentType, setEquipmentType] = React.useState("");

  return (
    <Modal show={show} size="md" centered backdropClassName="custom-backdrop">
      <Modal.Header>
        <h4>{t("add_equipment_type")}</h4>
        <div className="d-flex justify-content-end">
          <ActionIconContainer onClick={onClose}>
            <i className="fi fi-rr-cross-small" />
          </ActionIconContainer>
        </div>
      </Modal.Header>
      <Modal.Body>
        <Container>
          <Row className="mb-2">
            <Col md={12}>
              <FormGroupLabel className="m-0">{t("equipment_type")}</FormGroupLabel>
              <FormItem disabled={false}>
                <input
                  type="text"
                  name="equipmentType"
                  value={equipmentType}
                  onChange={(e) => setEquipmentType(e.target.value)}
                  //defaultValue=""
                  placeholder={t("equipment_type")}
                  style={formInputStyles}
                  disabled={false}
                />
              </FormItem>
              {equipmentTypePopupErr && <Error error={equipmentTypePopupErr} />}
            </Col>
          </Row>
        </Container>
      </Modal.Body>

      <Modal.Footer>
        <AddFormButton
          id="save-form-button"
          type="button"
            onClick={() => onAddEquipmentType(equipmentType)}
          disabled={!equipmentType.trim()}
        >
          {t("save")}
        </AddFormButton>
      </Modal.Footer>
    </Modal>
  );
};

export default CreateEquipmentTypePopup;
